import { FormikProps } from 'formik'
import { TagMultiSelect, CheckboxField } from 'components/FormFields/FormFields'
import { Divider, Tooltip } from '@pepper/ui'
import { FEEDBACK_TOOLTIPS } from '@pepper/utils/src/constant/enum/feedback_tooltips_info'
import { Info } from 'react-feather'
import { Values } from './schema'

import styles from './_.module.css'

interface Props {
  formik: FormikProps<Values>
  option: ReworkArea
  handleReworkPointChange: (value: string, action: FormikProps<Values>) => void
  type?: string
}

export const FeedbackCheckBoxList = ({
  option,
  handleReworkPointChange,
  formik,
  type,
}: Props): JSX.Element => {
  const getTooltipText = () => {
    const isTypeEqualsSubmit = type === 'submit'

    const feedbackTooltTips = FEEDBACK_TOOLTIPS[option?.key]

    return isTypeEqualsSubmit
      ? feedbackTooltTips?.submissionTooltipText ?? option.title
      : feedbackTooltTips?.reworkTooltipText ?? option.title
  }

  return (
    <div className={styles.ratingBlock} key={option.key}>
      <div className={styles.issueTitleContainer}>
        <CheckboxField
          name="rework_points"
          showError={false}
          fieldProps={{
            onChange: e => {
              handleReworkPointChange(option.key, formik)
            },
            value: formik.values.rework_points,
            options: [
              {
                label: option.title,
                value: option.key,
              },
            ],
          }}
        />
        {/* If the field is additional feedback then show the info section without tooltip else inside tooltip */}
        {option.key === 'additional_feedback' ? (
          <span className={styles.subText}>
            <Info size={12} />
            Select this if you want to original draft to be tweaked in certain
            ways
          </span>
        ) : (
          <Tooltip
            className={styles.tooltip}
            placement="bottom"
            overlayClassName={styles.tooltip}
            title={getTooltipText()}
          >
            <Info size={16} className={styles.infoIcon} />
          </Tooltip>
        )}
      </div>

      {formik.values.rework_points.includes(option.key) && (
        <div className={styles.subOptions}>
          <TagMultiSelect
            name={`${option.key}_options`}
            showError={false}
            label=""
            required={false}
            options={option.rework_inputs.map(({ id, title }) => ({
              title,
              id,
              color: 'orange',
            }))}
          />
        </div>
      )}
      {typeof formik.errors[`${option.key}_options`] === 'string' &&
        formik.values.rework_points.includes(option.key) && (
          <div className={styles.error}>
            {formik.errors[`${option.key}_options`]}
          </div>
        )}
      <Divider />
    </div>
  )
}
